import { VStack } from "@chakra-ui/react";
import React from "react";
import OperatorViewCard from "./OperatorViewCard";
import IncomingCallCard from "./IncomingCallCard";

/**
 * Renders the sidebar card
 * 
 * @param {Object} props - The props of the component
 * @returns The sidebar card
 */
const SidebarCard = ({ children, ...props }) => (
  <VStack alignItems={"stretch"} gap={"16px"} {...props}>
    <OperatorViewCard flexGrow={1} />
    <IncomingCallCard flexGrow={1} />
    {children}
  </VStack>
);

export default React.memo(SidebarCard);
